import styled from 'styled-components'

const RunningTextStyle = styled.div`
	margin-top: var(--sectionMargin);

	.line {
		transform: translateY(100%);
	}

	.container {
		.scrollingWrap {
			display: inline-flex;
			width: auto;
			h2 {
				white-space: nowrap;
			}
			.duplicateWrap {
				position: absolute;
				top: 0;
				left: 100%;
				width: 100vw;
			}
		}
	}

	i,
	.icon-coin,
	.icon-diamond,
	.icon-youtube {
		width: var(--sp20x);
		height: var(--sp20x);
		font-size: var(--sp20x);
		margin: 0 var(--sp8x);
		transition: var(--trTime2);
		fill: var(--orange);

		@media (hover: hover) {
			&:hover {
				transform: scale(1.1) rotate(20deg);
			}
		}
	}

	.secondLine {
		margin-top: var(--sp7x);
		i {
			transition: var(--trTime2);
			@media (hover: hover) {
				&:hover {
					transform: scale(1.1) rotate(-20deg);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		i,
		.icon-coin,
		.icon-diamond,
		.icon-youtube {
			width: var(--sp16x);
			height: var(--sp16x);
			font-size: var(--sp16x);
			margin: 0 var(--sp6x);
		}

		.secondLine {
			margin-top: var(--sp6x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		i,
		.icon-coin,
		.icon-diamond,
		.icon-youtube {
			width: var(--sp11x);
			height: var(--sp11x);
			font-size: var(--sp11x);
			margin: 0 var(--sp5x);
		}

		.secondLine {
			margin-top: var(--sp5x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		i,
		.icon-coin,
		.icon-diamond,
		.icon-youtube {
			width: var(--sp8x);
			height: var(--sp8x);
			font-size: var(--sp8x);
			margin: 0 var(--sp4x);
		}

		.secondLine {
			margin-top: var(--sp4x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.secondLine {
			margin-top: var(--sp4x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		i,
		.icon-coin,
		.icon-diamond,
		.icon-youtube {
			width: var(--sp5x);
			height: var(--sp5x);
			font-size: var(--sp5x);
			margin: 0 var(--sp2x);
		}

		.secondLine {
			margin-top: var(--sp3x);
		}
	}
`

export default RunningTextStyle
